import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { updateMigratorState } from '..';
export const useRegisterStateHead = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(updateMigratorState, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetMigratorList');
            setAction({
                type: 'success',
                message: 'State was registered successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
